import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import "../../../assets/css/doctor/doctorpages/Appointments.css";
import DoctorMasterLayout from "../doctorlayouts/DoctorMasterLayout";
import VideoCallRoom from "../../../components/videocall/VideoCallRoom";
import { AppContext } from "../../../context/AppContext";

// ── Inline SVG Icons ──────────────────────────────────────────────────────────
const CalendarIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <line x1="8" y1="14" x2="8" y2="14" strokeWidth="2.5"/>
    <line x1="12" y1="14" x2="12" y2="14" strokeWidth="2.5"/>
    <line x1="16" y1="14" x2="16" y2="14" strokeWidth="2.5"/>
    <line x1="8" y1="18" x2="8" y2="18" strokeWidth="2.5"/>
    <line x1="12" y1="18" x2="12" y2="18" strokeWidth="2.5"/>
  </svg>
);

const CircleCheckIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const ClockIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 7 12 12 15.5 14"/>
  </svg>
);

const ChecksIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 12 8 16 16 8"/>
    <polyline points="9 12 13 16 21 8"/>
  </svg>
);

const CircleXIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

const UserIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const DoubleCheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 12 8 16 16 8"/>
    <polyline points="9 12 13 16 21 8"/>
  </svg>
);

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const PrescriptionIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
    <rect x="9" y="3" width="6" height="4" rx="2"/>
    <line x1="9" y1="12" x2="15" y2="12"/>
    <line x1="9" y1="16" x2="13" y2="16"/>
  </svg>
);

const LinkIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);

const DownloadIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

const CalendarOffIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <line x1="9" y1="14" x2="15" y2="20"/>
    <line x1="15" y1="14" x2="9" y2="20"/>
  </svg>
);
// ─────────────────────────────────────────────────────────────────────────────

const Appointments = () => {
  const { baseUrl } = useContext(AppContext);
  const token = localStorage.getItem("doctor_token");

  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const [prescriptionAppointment, setPrescriptionAppointment] = useState(null);
  const [prescriptionText, setPrescriptionText] = useState('');
  const [prescriptionSaving, setPrescriptionSaving] = useState(false);

  // ── Per-row action states ──
  const [acceptingIds, setAcceptingIds]   = useState({});
  const [rejectingIds, setRejectingIds]   = useState({});
  const [completingIds, setCompletingIds] = useState({});

  const authHeaders = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };

  // ── Fetch appointments ──────────────────────────────────────
  const fetchAppointments = useCallback(() => {
    setLoading(true);
    axios.get(`${baseUrl}/doctor/Bookings/list`, { headers: authHeaders })
      .then((res) => {
        setAppointments(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'status-confirmed';
      case 'pending':   return 'status-pending';
      case 'completed': return 'status-completed';
      case 'rejected':  return 'status-cancelled';
      case 'cancelled': return 'status-cancelled';
      default:          return '';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed': return <CircleCheckIcon size={14} />;
      case 'pending':   return <ClockIcon size={14} />;
      case 'completed': return <ChecksIcon size={14} />;
      case 'rejected':  return <CircleXIcon size={14} />;
      case 'cancelled': return <CircleXIcon size={14} />;
      default:          return null;
    }
  };

  const filterAppointments = () => {
    let filtered = appointments;
    if (activeTab !== 'all') {
      filtered = filtered.filter((apt) => apt.status === activeTab);
    }
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter((apt) =>
        (apt.patient?.name || '').toLowerCase().includes(q) ||
        (apt.patient?.phone || '').includes(searchQuery) ||
        (apt.session_type || '').toLowerCase().includes(q)
      );
    }
    return filtered;
  };

  // ── Accept ──────────────────────────────────────────────────
  const handleAccept = (id) => {
    setAcceptingIds((prev) => ({ ...prev, [id]: true }));
    axios.post(`${baseUrl}/doctor/Bookings/${id}/accept`, {}, { headers: authHeaders })
      .then(() => {
        Swal.fire({ icon: 'success', title: 'Accepted', text: 'Booking confirmed successfully.', timer: 2000, showConfirmButton: false });
        fetchAppointments();
      })
      .catch((err) => {
        Swal.fire({ icon: 'error', title: 'Failed', text: err?.response?.data?.message || 'Something went wrong.' });
      })
      .finally(() => setAcceptingIds((prev) => ({ ...prev, [id]: false })));
  };

  // ── Reject (needs reason) ──────────────────────────────────
  const handleReject = (id) => {
    Swal.fire({
      title: 'Reject Booking?',
      icon: 'warning',
      input: 'textarea',
      inputPlaceholder: 'Reason for rejection (required)',
      showCancelButton: true,
      confirmButtonText: 'Yes, Reject',
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#64748b',
      inputValidator: (value) => {
        if (!value) return 'Please provide a reason for rejection';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setRejectingIds((prev) => ({ ...prev, [id]: true }));
        axios.post(`${baseUrl}/doctor/Bookings/${id}/reject`, { reason: result.value }, { headers: authHeaders })
          .then(() => {
            Swal.fire({ icon: 'success', title: 'Rejected', text: 'Booking has been rejected.', timer: 2000, showConfirmButton: false });
            fetchAppointments();
          })
          .catch((err) => {
            Swal.fire({ icon: 'error', title: 'Failed', text: err?.response?.data?.message || 'Something went wrong.' });
          })
          .finally(() => setRejectingIds((prev) => ({ ...prev, [id]: false })));
      }
    });
  };

  // ── Mark as Complete ───────────────────────────────────────
  const handleComplete = (id) => {
    Swal.fire({
      title: 'Mark session as completed?',
      text: 'This will credit the session fee to your wallet.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Complete',
      confirmButtonColor: '#17a2b8',
    }).then((result) => {
      if (result.isConfirmed) {
        setCompletingIds((prev) => ({ ...prev, [id]: true }));
        axios.post(`${baseUrl}/doctor/Bookings/${id}/complete`, {}, { headers: authHeaders })
          .then((res) => {
            Swal.fire({ icon: 'success', title: 'Completed', text: res.data.message, timer: 2500, showConfirmButton: false });
            fetchAppointments();
          })
          .catch((err) => {
            Swal.fire({ icon: 'error', title: 'Failed', text: err?.response?.data?.message || 'Something went wrong.' });
          })
          .finally(() => setCompletingIds((prev) => ({ ...prev, [id]: false })));
      }
    });
  };

  // ── View modal ──────────────────────────────────────────────
  const handleOpenModal = (appointment) => setSelectedAppointment(appointment);
  const handleCloseModal = () => setSelectedAppointment(null);

  const [showVideoCall, setShowVideoCall] = useState(false);
const [activeAppointmentId, setActiveAppointmentId] = useState(null);

const handleJoinSession = (appointment) => {
  setActiveAppointmentId(appointment.id);
  setShowVideoCall(true);
};

  // ── Prescription ────────────────────────────────────────────
  const handleOpenPrescription = (appointment) => {
    setPrescriptionAppointment(appointment);
    setPrescriptionText(appointment.prescription?.content || '');
  };

  const handleClosePrescription = () => {
    setPrescriptionAppointment(null);
    setPrescriptionText('');
  };

const handleSavePrescription = () => {
    if (!prescriptionText.trim()) {
      Swal.fire({ icon: 'warning', title: 'Empty Prescription', text: 'Please write something before saving.' });
      return;
    }
    setPrescriptionSaving(true);
    axios.post(`${baseUrl}/doctor/Prescription/create`, {
      appointment_id: prescriptionAppointment.id,
      content: prescriptionText,
    }, { headers: authHeaders })
      .then((res) => {
        Swal.fire({ icon: 'success', title: 'Saved', text: 'Prescription saved successfully.', timer: 2000, showConfirmButton: false });
        // Modal band karne ke bajaye, prescription data update kar dein taake Download button turant dikhe
        setPrescriptionAppointment((prev) => ({
          ...prev,
          prescription: res.data.data,
        }));
        fetchAppointments();
      })
      .catch((err) => {
        Swal.fire({ icon: 'error', title: 'Failed', text: err?.response?.data?.message || 'Something went wrong.' });
      })
      .finally(() => setPrescriptionSaving(false));
  };

  const handleDownloadPrescription = () => {
    if (!prescriptionAppointment?.prescription?.id) return;
    const url = `${baseUrl}/doctor/Prescription/${prescriptionAppointment.prescription.id}/download`;
    axios.get(url, { headers: authHeaders, responseType: 'blob' })
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `prescription_${prescriptionAppointment.id}.pdf`;
        link.click();
      })
      .catch(() => {
        Swal.fire({ icon: 'error', title: 'Failed', text: 'Could not download prescription.' });
      });
  };

  const stats = {
    total:     appointments.length,
    confirmed: appointments.filter((a) => a.status === 'confirmed').length,
    pending:   appointments.filter((a) => a.status === 'pending').length,
    completed: appointments.filter((a) => a.status === 'completed').length,
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return '-';
    const [h, m] = timeStr.split(':');
    const hour = parseInt(h, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${String(h12).padStart(2, '0')}:${m} ${period}`;
  };

  return (
    <DoctorMasterLayout>
      <div className="appointments-container">
        <div className="appointments-content">

          {/* ── Header ── */}
          <div className="appointments-header">
            <div className="header-left">
              <h2>Appointments Management</h2>
              <p>Manage and track all your patient appointments</p>
            </div>
          </div>

          {/* ── Stats Cards ── */}
          <div className="appointments-stats">
            <div className="stat-card-apt">
              <div className="stat-icon-apt total"><CalendarIcon /></div>
              <div className="stat-info-apt"><h4>{stats.total}</h4><p>Total</p></div>
            </div>
            <div className="stat-card-apt">
              <div className="stat-icon-apt confirmed"><CircleCheckIcon size={22} /></div>
              <div className="stat-info-apt"><h4>{stats.confirmed}</h4><p>Confirmed</p></div>
            </div>
            <div className="stat-card-apt">
              <div className="stat-icon-apt pending"><ClockIcon size={22} /></div>
              <div className="stat-info-apt"><h4>{stats.pending}</h4><p>Pending</p></div>
            </div>
            <div className="stat-card-apt">
              <div className="stat-icon-apt completed"><ChecksIcon size={22} /></div>
              <div className="stat-info-apt"><h4>{stats.completed}</h4><p>Completed</p></div>
            </div>
          </div>

          {/* ── Filters & Search ── */}
          <div className="appointments-controls">
            <div className="tabs-container">
              {['all', 'pending', 'confirmed', 'completed', 'rejected'].map((tab) => (
                <button
                  key={tab}
                  className={'tab-btn' + (activeTab === tab ? ' active' : '')}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            <div className="search-box">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search by patient name, phone, or type..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* ── Table ── */}
          <div className="appointments-table-wrapper">
            {loading ? (
              <div className="no-appointments">
                <p>Loading appointments...</p>
              </div>
            ) : filterAppointments().length === 0 ? (
              <div className="no-appointments">
                <CalendarOffIcon />
                <h3>No Appointments Found</h3>
                <p>There are no appointments matching your criteria</p>
              </div>
            ) : (
              <table className="appointments-table">
                <thead>
                  <tr>
                    <th>Patient Name</th>
                    <th>Phone</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filterAppointments().map((appointment) => {
                    const isAccepting  = !!acceptingIds[appointment.id];
                    const isRejecting  = !!rejectingIds[appointment.id];
                    const isCompleting = !!completingIds[appointment.id];

                    return (
                      <tr key={appointment.id}>
                        <td data-label="Patient Name">
                          <div className="patient-name-cell">
                            <div className="patient-avatar"><UserIcon size={18} /></div>
                            <span>{appointment.patient?.name || 'N/A'}</span>
                          </div>
                        </td>
                        <td data-label="Phone">{appointment.patient?.phone || 'N/A'}</td>
                        <td data-label="Date">{formatDate(appointment.appointment_date)}</td>
                        <td data-label="Time">{formatTime(appointment.appointment_time)}</td>
                        <td data-label="Type">{appointment.session_type}</td>
                        <td data-label="Status">
                          <span className={'status-badge ' + getStatusColor(appointment.status)}>
                            {getStatusIcon(appointment.status)}
                            {appointment.status.charAt(0).toUpperCase() + appointment.status.slice(1)}
                          </span>
                        </td>
                        <td data-label="Actions">
                          <div className="table-actions-row">
                            {appointment.status === 'pending' && (
                              <>
                                <button
                                  className={'action-btn confirm' + (isAccepting ? ' btn-loading' : '')}
                                  onClick={() => handleAccept(appointment.id)}
                                  disabled={isAccepting}
                                  title="Accept Booking"
                                >
                                  <span className="btn-icon"><CheckIcon /></span>
                                  <span className="btn-label">Accept</span>
                                </button>
                                <button
                                  className={'action-btn cancel' + (isRejecting ? ' btn-loading' : '')}
                                  onClick={() => handleReject(appointment.id)}
                                  disabled={isRejecting}
                                  title="Reject Booking"
                                >
                                  <span className="btn-icon"><XIcon size={16} /></span>
                                  <span className="btn-label">Reject</span>
                                </button>
                              </>
                            )}
                            {appointment.status === 'confirmed' && (
                              <button
                                className={'action-btn complete' + (isCompleting ? ' btn-loading' : '')}
                                onClick={() => handleComplete(appointment.id)}
                                disabled={isCompleting}
                                title="Mark as Completed"
                              >
                                <span className="btn-icon"><DoubleCheckIcon /></span>
                                <span className="btn-label">Complete</span>
                              </button>
                            )}
                          </div>
                          <div className="table-actions-row">
                            <button
                              className="action-btn view"
                              onClick={() => handleOpenModal(appointment)}
                              title="View Details"
                            >
                              <span className="btn-icon"><EyeIcon /></span>
                              <span className="btn-label">View</span>
                            </button>
                            {appointment.status === 'completed' && (
                              <button
                                className="action-btn prescription"
                                onClick={() => handleOpenPrescription(appointment)}
                                title="Prescription"
                              >
                                <span className="btn-icon"><PrescriptionIcon size={16} /></span>
                                <span className="btn-label">Rx</span>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* ── View Appointment Modal ── */}
        {selectedAppointment && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content view-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Appointment Details</h3>
                <button className="close-modal" onClick={handleCloseModal}><XIcon size={20} /></button>
              </div>

              <div className="modal-body">
                <div className="detail-section">
                  <h4>Patient Information</h4>
                  <div className="detail-row">
                    <span className="detail-label">Name:</span>
                    <span className="detail-value">{selectedAppointment.patient?.name || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">{selectedAppointment.patient?.email || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">{selectedAppointment.patient?.phone || 'N/A'}</span>
                  </div>
                </div>

                <div className="detail-section">
                  <h4>Appointment Information</h4>
                  <div className="detail-row">
                    <span className="detail-label">Date:</span>
                    <span className="detail-value">
                      {new Date(selectedAppointment.appointment_date).toLocaleDateString('en-US', {
                        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                      })}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Time:</span>
                    <span className="detail-value">{formatTime(selectedAppointment.appointment_time)}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Type:</span>
                    <span className="detail-value">{selectedAppointment.session_type}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Fee:</span>
                    <span className="detail-value">{selectedAppointment.fee ? `Rs. ${selectedAppointment.fee}` : 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Status:</span>
                    <span className={'status-badge ' + getStatusColor(selectedAppointment.status)}>
                      {getStatusIcon(selectedAppointment.status)}
                      {selectedAppointment.status.charAt(0).toUpperCase() + selectedAppointment.status.slice(1)}
                    </span>
                  </div>
                </div>

                {selectedAppointment.status === 'rejected' && selectedAppointment.rejection_reason && (
                  <div className="detail-section">
                    <h4>Rejection Reason</h4>
                    <p className="rejection-reason-text">{selectedAppointment.rejection_reason}</p>
                  </div>
                )}

                {selectedAppointment.status === 'confirmed' && selectedAppointment.jitsi_room_name && (
                  <div className="detail-section session-link-section">
                    <h4><LinkIcon size={18} /> Session</h4>
                    <p style={{ marginBottom: '14px', color: '#666', fontSize: '0.9rem' }}>
                      Click below to join the video session with your patient.
                    </p>
                    <button
                      className="join-session-btn"
                      onClick={() => handleJoinSession(selectedAppointment)}
                    >
                      <LinkIcon size={18} /> Join Session
                    </button>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button className="cancel-modal-btn" onClick={handleCloseModal}>Close</button>
              </div>
            </div>
          </div>
        )}

        {/* ── Prescription Modal ── */}
        {prescriptionAppointment && (
          <div className="modal-overlay" onClick={handleClosePrescription}>
            <div className="modal-content prescription-modal" onClick={(e) => e.stopPropagation()}>

              <div className="modal-header prescription-modal-header">
                <div className="prescription-header-info">
                  <div className="prescription-header-icon"><PrescriptionIcon size={22} /></div>
                  <div>
                    <h3>Prescription</h3>
                    <span className="prescription-patient-name">
                      {prescriptionAppointment.patient?.name || 'Patient'}
                    </span>
                  </div>
                </div>
                <button className="close-modal" onClick={handleClosePrescription}><XIcon size={20} /></button>
              </div>

              <div className="modal-body prescription-modal-body">
                <div className="rx-add-section">
                  <h4 className="rx-section-title">
                    <PrescriptionIcon size={16} />
                    Write Prescription / Notes
                  </h4>
                  <textarea
                    className="rx-textarea"
                    rows={8}
                    placeholder="Write exercises, notes, or recommendations for the patient..."
                    value={prescriptionText}
                    onChange={(e) => setPrescriptionText(e.target.value)}
                  />
                </div>
              </div>

              <div className="modal-footer">
                {prescriptionAppointment.prescription?.id && (
                  <button className="download-rx-btn" onClick={handleDownloadPrescription}>
                    <DownloadIcon size={16} /> Download PDF
                  </button>
                )}
                <button className="cancel-modal-btn" onClick={handleClosePrescription}>Cancel</button>
                <button
                  className="save-rx-btn"
                  onClick={handleSavePrescription}
                  disabled={prescriptionSaving}
                >
                  {prescriptionSaving ? 'Saving...' : 'Save Prescription'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
      {/* ── Video Call Modal ── */}
{showVideoCall && activeAppointmentId && (
  <VideoCallRoom
    appointmentId={activeAppointmentId}
    userType="therapist"
    baseUrl={baseUrl}
    authHeaders={authHeaders}
    onClose={() => {
      setShowVideoCall(false);
      setActiveAppointmentId(null);
      fetchAppointments();
    }}
  />
)}
    </DoctorMasterLayout>
  );
};

export default Appointments;